import { Link } from 'react-router-dom';
import { Box, Button, Modal, Typography } from '@mui/material';

/**
 *
 * @param {boolean}       isOpen      - Is the modal open or closed
 * @param {Function}      handleClose - Callback when the modal is closed
 * @returns {JSX.Element}               Modal to be displayed when a user selects 'No'
 */
export default function PopUp({ isOpen, handleClose }) {
  return (
    <div>
      <Modal open={isOpen} onClose={handleClose}>
        <Box className="absolute left-1/2 top-1/2 flex w-3/4 -translate-x-1/2 -translate-y-1/2 flex-col border border-2 border-black bg-white shadow-md md:w-1/2">
          <Button
            color="error"
            onClick={handleClose}
            size="small"
            sx={{ marginLeft: 'auto', minWidth: 0, marginRight: 1, marginTop: 1 }}
            variant="outlined"
          >
            X
          </Button>
          <Box className="flex flex-col gap-6 p-6">
            <Typography className="text-center">
              Because you answered &quot;No&quot; to this condition, you may need to apply for a
              Utah County Commission Appeal. You can access this online application by following the
              link below
            </Typography>
            <Typography className="text-center">
              <Link
                className="font-medium text-blue-600 hover:underline dark:text-blue-500"
                to={`/personal-property-settlement-form`}
                target="_blank"
                rel="noreferrer"
              >
                Application For Settlement or Deferral of Delinquent Property Tax
              </Link>
            </Typography>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
